import React, { Component } from 'react';
import Calendar from 'react-calendar';
import moment from 'moment';
import 'react-calendar/dist/Calendar.css';
import Config from '../Config'


class Datum extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedUser: props.selectedUser,
      selectedDate: props.selectedDate,
      ChangeDate: props.ChangeDate
    }
    // hold the currently loaded user for the component
    this.loadedUser = "";
  }

  componentDidMount() {
    this.loadData(this.props.selectedUser,this.props.selectedDate);
  }

  componentDidUpdate() {
    this.loadData(this.props.selectedUser, this.props.selectedDate);
  }

  loadData(selectedUser, date) {
    if (selectedUser === this.loadedUser) return;
    this.loadedUser = selectedUser;

    // load information of planned servicecalls
    const url = Config.DigibonServiceBase + "planned?startdate=" + moment(date).startOf('month').format('YYYY-MM-DD') + "&technicianCode=" + selectedUser
    fetch(url, Config.GetBearer())
      .then((res) => { return res.ok ? res.json() : { status: res.status } })
      .then((json) => {
        if (json.status === 401) {
          alert("Het is noodzakelijk opnieuw in te loggen");
          return;
        }
        this.setState({ planned: json });
      }).catch((error) => {
        console.log(error);
      });
  }

  onActiveStartDateChange(date) {
    this.loadedUser=null;   // force to reload data
    this.loadData(this.props.selectedUser, date.activeStartDate);
  }

  onChange(date) {
    if (date instanceof Date) {
      this.setState({
        selectedDate: date
      });
      if (this.state.ChangeDate != null) {
        this.state.ChangeDate(date);
      }

    }
  }
  selectToday() {
    this.state.ChangeDate(new Date());
  }

  tileClassName(e) {
    if (!this.state.planned) return "";
    if (this.state.planned.find(p => p.startDate === moment(e.date).format('YYYY-MM-DDT00:00:00'))) {
      return "bold";
    }
    return "";
  }

  render() {

    return <div className="row">
      <div className="col">
        <div >
          <Calendar value={this.state.selectedDate} tileClassName={this.tileClassName.bind(this)} 
            onActiveStartDateChange={(e) => this.onActiveStartDateChange(e)}
            onChange={(e) => this.onChange(e)} />
        </div>
        <div>
          Geselecteerde datum: {this.state == null ? "" : moment(this.state.selectedDate).format('DD-MM-YYYY')}
        </div>
      </div>
      <div className="col">
        {moment(this.state.selectedDate).format('DD-MM-YYYY') !== moment(new Date()).format('DD-MM-YYYY') && 
          <button className="btn btn-primary" onClick={this.selectToday.bind(this)}>selecteer vandaag</button>
        }
      </div>
    </div>
  }
}

export default Datum;